import React from "react";
import StyledModal from "../../../components/CustomModal";
import { FooterButtons, FormWrapper } from "../../../components/styles";
import { AddButton } from "../../Category/styles";
import { Form, Input } from "antd";

interface AddUpdateStickyModalProps {
    handleFormSubmit: (values: any) => void;
    isMarkModalOpen: boolean;
    handleMarkCancel: () => void;
    form: any; // Form instance from antd Form component
    title: string;
    confirmLabel: string;
    loading: boolean;
}

const AddUpdateCommentModal: React.FC<AddUpdateStickyModalProps> = ({ title, confirmLabel, handleFormSubmit, isMarkModalOpen, handleMarkCancel, form, loading, }) => {

    return (
        <StyledModal
            draggable={true}
            title={title}
            centered
            open={isMarkModalOpen}
            onCancel={handleMarkCancel}
            footer={
                <FooterButtons>
                    <AddButton disabled={loading} onClick={handleMarkCancel}>Cancel</AddButton>
                    <AddButton loading={loading} onClick={() => form.submit()} type="primary">
                        {confirmLabel}
                    </AddButton>
                </FooterButtons>
            }
        >
            <FormWrapper disabled={loading} form={form} name="Update_Comment" layout="vertical" onFinish={handleFormSubmit}>
                <Form.Item
                    name="note"
                    label="Comment"
                    rules={[
                        { required: true, message: "Please write a Comment." }, // Validation rule
                    ]}
                >
                    <Input.TextArea rows={4} placeholder="Write a Comment" />
                </Form.Item>
            </FormWrapper>
        </StyledModal>
    );
};

export default AddUpdateCommentModal;
